import { Component } from '@angular/core';

@Component({
  selector: 'fullscreen-page',
  templateUrl: './fullscreen-page.component.html',
  styleUrls: ["./fullscreen-page.component.css"]
})
export class FullscreenPageComponent {

}